import { Box, Button, MenuItem, TextField } from '@mui/material'
import React, { useEffect } from 'react'

import { FeaturePackageConfirm } from '../shared/FeaturePackageConfirm'
import { FeaturesPackagesList } from '../shared/FeaturesPackagesList'
import { LockedSchoolsIds } from '../../utility/utils'
import {
  useSetAtom,
  useAtom,
  useAtomValue,
} from 'infrastructure/state/jotai.wrapper'
import {
  availableSchoolPackagesAtom,
  selectedActionAtom,
  selectedFeaturePackageAtom,
  selectedSchoolsAtom,
} from 'shared/api/platformFeatures'
import { schoolResponseAtom } from 'shared/api/school'

export function SchoolFeatures() {
  const [school, reFetchSchool] = useAtom(schoolResponseAtom)
  const setSelectedAction = useSetAtom(selectedActionAtom)
  const schoolSetter = useSetAtom(selectedSchoolsAtom)
  const [selectedPackageName, setSelectedPackageName] = useAtom(
    selectedFeaturePackageAtom,
  )
  const availablePackages = useAtomValue(availableSchoolPackagesAtom)

  useEffect(() => {
    if (!school) {
      schoolSetter([])
    } else {
      schoolSetter([school])
    }
  }, [school, schoolSetter])

  const removeSchoolPackageButton = (packageName: string) => {
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          setSelectedPackageName(packageName)
          setSelectedAction({ actionType: 'remove', entityType: 'school' })
        }}
      >
        Remove from school
      </Button>
    )
  }

  const closeDialog = () => {
    reFetchSchool()
  }

  return (
    <>
      <Box>
        <Box>
          {school?.features.length ? (
            <>
              <p>
                <b>School feature packages:</b>
              </p>
              <FeaturesPackagesList
                platformFeatures={school.features}
                childrenForFeaturePackage={removeSchoolPackageButton}
              />
            </>
          ) : (
            <Box sx={{ p: 2 }}>
              <b>There are no school feature packages available</b>
            </Box>
          )}
        </Box>
        <br />
        {availablePackages.length > 0 && (
          <Box sx={{ maxWidth: 300, minWidth: 120 }}>
            <TextField
              fullWidth
              value={selectedPackageName}
              disabled={!school || LockedSchoolsIds.includes(school.id)}
              label="Select school feature package"
              variant="outlined"
              onChange={(e: any) => setSelectedPackageName(e.target.value)}
              select
              size="small"
            >
              {availablePackages.map((packageName: any) => {
                return (
                  <MenuItem key={packageName} value={packageName}>
                    {packageName}
                  </MenuItem>
                )
              })}
            </TextField>
            <Box mt={2}>
              <Button
                disabled={!selectedPackageName}
                onClick={() =>
                  setSelectedAction({ actionType: 'add', entityType: 'school' })
                }
                variant="outlined"
              >
                Add Feature Package
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      <FeaturePackageConfirm onCloseDialog={closeDialog} />
    </>
  )
}
